import { IconProps } from './types'

export const LandSize = ({ className }: IconProps) => {
  return (
    <svg
      width='31'
      height='30'
      viewBox='0 0 31 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M18.4129 19.8132C17.1912 22.0703 15.9469 24.0669 15.5255 24.731C15.4577 24.6209 15.369 24.4751 15.2625 24.2983C15.0343 23.9191 14.7259 23.3992 14.3712 22.7852C13.661 21.5561 12.7681 19.9557 11.9604 18.3556C11.3724 17.1908 10.8353 16.0371 10.4467 15.0325C10.0476 14.0006 9.8418 13.2155 9.8418 12.7508C9.8418 9.66241 12.3869 7.13254 15.5238 7.13248C18.6657 7.13248 21.2058 9.66193 21.2058 12.7508C21.2058 13.4287 20.9009 14.4939 20.3652 15.7957C19.8408 17.0698 19.1342 18.4806 18.4129 19.8132Z'
        stroke='currentColor'
        stroke-width='1.40625'
      />
      <path
        d='M3 14.2674V28.8996C3 28.955 3.04497 29 3.10045 29H28.8996C28.955 29 29 28.955 29 28.8996V2.10045C29 2.04497 28.955 2 28.8996 2H14.4174'
        stroke='currentColor'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-dasharray='5.02 5.02'
      />
      <path
        d='M4.93454 8.91367C4.75941 8.87575 4.58421 8.8374 4.4123 8.79926C3.53008 8.60353 2.80035 8.42711 2.56973 8.34286C2.36543 8.26822 2.26798 8.18097 2.23091 8.12662C2.2149 8.10314 2.20745 8.08268 2.20434 8.06012C2.20387 8.0567 2.20344 8.05283 2.20312 8.04848C2.24586 8.04819 2.29595 8.05137 2.35124 8.05852L4.93454 8.91367ZM4.93454 8.91367C4.90254 8.90121 4.87027 8.88871 4.83777 8.87617C4.04808 8.5715 3.18071 8.26889 2.56019 8.10019L4.93454 8.91367Z'
        stroke='currentColor'
        stroke-width='1.29058'
      />
      <path
        d='M6.93776 6.47271C6.67493 6.27841 6.40565 6.07796 6.14579 5.88254C5.38512 5.31049 4.75923 4.82118 4.57253 4.63768C4.4058 4.47381 4.34516 4.34126 4.3316 4.26327C4.32559 4.22867 4.32756 4.20027 4.33604 4.17179C4.33976 4.15931 4.34575 4.14349 4.35568 4.12451C4.40622 4.14432 4.46583 4.17477 4.52993 4.21452C4.60183 4.25911 4.66718 4.30782 4.71624 4.34847C5.2397 4.78219 5.94132 5.452 6.56686 6.08929C6.6964 6.22126 6.82064 6.34977 6.93776 6.47271Z'
        stroke='currentColor'
        stroke-width='1.29058'
      />
      <path
        d='M7.8621 2.03801C8.17678 2.62043 8.56602 3.47112 8.90145 4.26823C8.81597 4.12696 8.73086 3.98573 8.64746 3.84658C8.16368 3.03936 7.77092 2.35708 7.66676 2.12036C7.57196 1.9049 7.56928 1.77228 7.58111 1.71683C7.58564 1.69559 7.59173 1.68607 7.59825 1.67841L7.59931 1.67719C7.69725 1.77036 7.79709 1.91768 7.8621 2.03801Z'
        stroke='currentColor'
        stroke-width='1.29058'
      />
      <circle
        cx='15.5'
        cy='12.5'
        r='2.5'
        stroke='currentColor'
        stroke-width='1.5'
      />
    </svg>
  )
}
